import { FolderItemType } from '@/service/type/Folder';
import useFolderStore from '@/state/folder-store';
import { useMemo } from 'react';

const useFolderNames = (folderId: number): string | undefined => {
  const { folderState } = useFolderStore();

  const findFolderPathById = (
    folders: FolderItemType[],
    id: number,
  ): string | undefined => {
    for (const folder of folders) {
      if (folder.id === id) {
        return folder.name;
      } else if (folder?.child_folder?.length > 0) {
        const childPath = findFolderPathById(folder.child_folder, id);
        if (childPath) {
          return `${folder.name} / ${childPath}`;
        }
      }
    }
    return undefined;
  };

  const folderName = useMemo(() => {
    return findFolderPathById(folderState, folderId);
  }, [folderId, folderState]);

  return folderName;
};

export default useFolderNames;
